import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH} from "@/content";

const slug = 'meter-installations-and-relocations-in-sydney';
const serviceId = 2
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: "Meter Installations & Relocations",
        description: "Meter Installations & Relocations - ProElec Group offers professional meter installation and relocation services in Sydney. Our licensed electricians specialize in installing new meters, upgrading existing ones, and relocating meters to suit your property's needs. Whether you're renovating, building a new home, or need to move your meter for better access, we provide safe and efficient solutions tailored to your requirements.",
        keywords: "meter installations Sydney, meter relocations Sydney, licensed electricians Sydney, electrical meter upgrade, new meter installation, safe meter relocation, professional electricians Sydney",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Meter Installations & Relocations',
    description: 'Installing or relocating electricity meters to comply with regulatory requirements.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
